import React from 'react';
import { createRoot } from 'react-dom/client';

import '@fortawesome/fontawesome-svg-core/attribution';
import { library } from '@fortawesome/fontawesome-svg-core';
import {faInfoCircle, faExternalLinkAlt, faChevronRight, faChevronLeft, faDollarSign, faBicycle, faWrench, faStoreAlt, faMap} from '@fortawesome/free-solid-svg-icons';

import App from './App';

import { GlobalProvider } from './contexts/GlobalContext';
import { LayerVisibilityContextProvider } from './contexts/LayerVisibilityContext';
import ViewPortProvider from './contexts/ViewPortContext';

import reportWebVitals from './reportWebVitals';

import './index.css';

library.add(
  faInfoCircle,
  faExternalLinkAlt,
  faChevronRight,
  faChevronLeft,
  faDollarSign,
  faBicycle,
  faWrench,
  faStoreAlt,
  faMap
);

const container = document.getElementById('root');
const root = createRoot(container);

// eslint-disable-next-line react/no-deprecated
root.render(
  <React.StrictMode>
    <GlobalProvider>
      <ViewPortProvider>
        <LayerVisibilityContextProvider>
          <App />
        </LayerVisibilityContextProvider>
      </ViewPortProvider>
    </GlobalProvider>
  </React.StrictMode>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
